import React from "react";

export const RequiredLabel = ({ children, required }) =>
    React.createElement(
        "span",
        { className: "fw-bold" },
        children,
        " ",
        required && React.createElement("span", { className: "text-danger" }, "*")
    );